import React from "react";
import { ModalsCloseIcon } from "../Icons";
import styles from "../statics/styles/modal-close-button.scss";
const ModalCloseButton = ({ closeModal }) => {
  return /* @__PURE__ */ React.createElement("div", { className: styles.modal_closeButton, onClick: closeModal }, /* @__PURE__ */ React.createElement(ModalsCloseIcon, null));
};
var ModalCloseButton_default = ModalCloseButton;
export {
  ModalCloseButton_default as default
};
//# sourceMappingURL=ModalCloseButton.js.map
